import React, { useState } from 'react';
import Select from '@atlaskit/select';
import { TransactionAccount, CommerceAddress } from '@css-xp/graphtypes';
import { CreditCard } from '@css-xp/graphtypes/src/generated-types-new';

export interface shipToAddressesType {
  transactionAccount: TransactionAccount;
}

const customStyles = {
  control: (base: Record<string, unknown>) => {
    return {
      ...base,
      height: '72px',
    };
  },
  valueContainer: (base: Record<string, unknown>) => ({
    ...base,
    height: '100%',
  }),
};

export const SelectNewBillToAddress = ({
  onSelect,
  shipToAddresses,
  defaultPayment,
  isEditable = true,
}: {
  onSelect: (option: any) => void;
  shipToAddresses: shipToAddressesType | undefined;
  defaultPayment: CreditCard | undefined;
  isEditable?: boolean | true;
}) => {
  const [value, setValue] = useState(undefined);
  const formatAddressLabel = (node: CommerceAddress) => {
    let label = '';
    if (node?.addressLine1) {
      label += node.addressLine1;
    }
    if (node?.addressLine2) {
      label += `, ${node.addressLine2}`;
    }
    if (node?.city) {
      label += `, ${node.city}`;
    }
    if (node?.state) {
      label += `, ${node.state}`;
    }
    if (node?.country) {
      label += `, ${node.country}`;
    }

    return (
      <div data-testid="bill-to-address-container">
        <h4>{node.name}</h4>
        <div>{label}</div>
        <div>{`Credit card: **** ${defaultPayment?.card?.last4Numbers}, exp - ${defaultPayment?.card?.expirationMonth}/${defaultPayment?.card?.expirationYear}`}</div>
      </div>
    );
  };

  const selectOptions = shipToAddresses?.transactionAccount.availableShipToParties?.nodes?.map((node) => {
    return {
      label: node && formatAddressLabel(node),
      value: node,
    };
  });

  const handleSelect = (option: any) => {
    onSelect(option);
    setValue(option);
  };

  return (
    <Select
      onChange={handleSelect}
      options={selectOptions}
      placeholder={'Select an existing sold-to address'}
      data-testid="select"
      styles={customStyles}
      isClearable
      value={value}
      loading={true}
      isSearchable
      isDisabled={!isEditable}
    />
  );
};
